import { siteContent } from '#app/utils/site/content'
import { type Audience, ctaHrefFor } from '#app/utils/site/site-links'
import { useOptionalUser } from '#app/utils/user'
import { BigHeading, Container, Pill, Reveal } from '../primitives'

/** The dark closing band: one big line and the audience's CTA. */
export function ClosingCta({ audience }: { audience: Audience }) {
	const copy = siteContent.closing[audience]
	const href = ctaHrefFor(copy.href, Boolean(useOptionalUser()))
	return (
		<section className="relative mt-20 overflow-hidden bg-tt-ink-2 py-[120px] pb-32 text-center text-white">
			<Container>
				<Reveal>
					<BigHeading
						as="h2"
						className="mx-auto max-w-[13ch] text-[clamp(52px,8.4vw,128px)]"
					>
						{copy.heading}
					</BigHeading>
					<div className="mt-10 flex flex-wrap items-center justify-center gap-[34px]">
						<Pill href={href} variant="white" arrow>
							{copy.cta}
						</Pill>
					</div>
				</Reveal>
			</Container>
		</section>
	)
}
